export const formatMarkdown = (text = "") => {
    const escaped = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");


    const withMdLinks = escaped.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );


    const linkified = withMdLinks.replace(
        /<a\s[^>]*>.*?<\/a>|https?:\/\/[^\s<]+|\bwww\.[^\s<]+/g,
        (match) => {
            if (match.startsWith("<a")) return match;


            const m = match.match(/^(.*?)([),.;!?]+)?$/);
            const urlPart = m?.[1] || match;
            const trailing = m?.[2] || "";

            if (urlPart.startsWith("www.")) {
                return `<a href="https://${urlPart}" target="_blank" rel="noopener noreferrer">${urlPart}</a>${trailing}`;
            }
            return `<a href="${urlPart}" target="_blank" rel="noopener noreferrer">${urlPart}</a>${trailing}`;
        }
    );

    const basic = linkified
        .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
        .replace(/(\*|_)(.+?)\1/g, "<em>$2</em>")
        .replace(/`([^`]+)`/g, "<code>$1</code>")
        .replace(/^---$/gm, "<hr />");

    const withLists = basic
        .replace(/(?:^|\n)(\d+\.\s.+(?:\n\d+\.\s.+)*)/g, (m) => {
            const items = m
                .trim()
                .split("\n")
                .map((line) => line.replace(/^\d+\.\s+/, ""))
                .map((item) => `<li>${item}</li>`)
                .join("");
            return `<ol>${items}</ol>`;
        })
        .replace(/(?:^|\n)(-\s.+(?:\n-\s.+)*)/g, (m) => {
            const items = m
                .trim()
                .split("\n")
                .map((line) => line.replace(/^-\s+/, ""))
                .map((item) => `<li>${item}</li>`)
                .join("");
            return `<ul>${items}</ul>`;
        });

    return withLists.replace(/\n/g, "<br />");
};